import React, { useState, useEffect } from "react";
import { Button, Col, message, Row, Space, Spin, Table } from "antd";
import { initUser, User } from "../../models";
import styles from "./User.module.css";
import { AddForm } from "./AddForm";
import { EditForm } from "./EditForm";
import {
  getTableAll,
  deleteTable,
  createTable,
  updateTable,
} from "../../api/Api";

import { loginInfo } from "../../config";
import { useHistory } from "react-router-dom";

export const UserPage: React.FC = () => {
  const [users, setUsers] = useState<User[]>([]);
  const [addFormVisible, setAddFormVisible] = useState(false);
  const [editFormVisible, setEditFormVisible] = useState(false);
  const [editRecord, setEditRecord] = useState<User>({ ...initUser });
  const [loading, setLoading] = useState(false);
  const history = useHistory();
  //const [schools,setSchools] = useState<School[]>([]);
  useEffect(() => {
    getUsers();
    //_getSchools();
  }, []);

  const getUsers = async () => {
    setLoading(true);
    let data = await getTableAll("user");
    if(typeof data === "undefined"){
      history.push("/");      
    }
    let _users: User[] = [];
    data.forEach((element) => {
      if (element.hospitalId === loginInfo.user.hospitalId && element.type !== 0) {
        _users.push({ ...element, key: element.id });
      }
    });
    setUsers(_users);
    setLoading(false);
  };

  const remove = async (id: number) => {
    setLoading(true);
    if (!loginInfo.user.user) {
      message.info("没有用户设置权限");
      setLoading(false);
      return;
    }
    await deleteTable("user", id);
    let _users: User[] = [];
    users.forEach((value, index) => {
      if (value.id === id) {
        if (users.length === 1) {
          setEditRecord({ ...initUser });
        } else {
          if (index === 0) {
            setEditRecord({ ...users[1], key: users[1].id });
          } else {
            setEditRecord({ ...users[index - 1], key: users[index - 1].id });
          }
        }
      } else {
        _users.push(value);
      }
    });
    setUsers(_users);
    setLoading(false);
  };
  const add = async (user: User) => {
    setLoading(true);
    if (users.findIndex((u) => u.userCode === user.userCode) !== -1) {
      message.info("登录名已存在,添加用户失败!");
      setLoading(false);
      return;
    }
    let data = await createTable("user", user);
    if(typeof data === "undefined"){
      history.push("/");      
    }
    let _users = [...users];
    _users.push({ ...data, key: data.id });
    setUsers(_users);
    setLoading(false);
  };
  const update = async (user: User) => {
    setLoading(true);
    let data = await updateTable("user", user);
    if(typeof data === "undefined"){
      history.push("/");      
    }
    let _users: User[] = [];
    users.forEach((u) => {
      if (u.id === user.id) {
        _users.push(user);
      } else {
        _users.push(u);
      }
    });
    setUsers(_users);
    setLoading(false);
  };

  const buildColumns = () => {
    return [
      {
        title: "操作",
        key: "action",
        dataIndex: "action",
        width: 150,
        render: (text: any, record: User) => {
          if (record.userCode === "admin") {
            return <span></span>;
          } else {
            return loginInfo.user.user ? (
              <Space size="small">
                <Button
                  type="primary"
                  size="small"
                  onClick={() => remove(record.id)}
                >
                  删除
                </Button>
                <Button
                  type="primary"
                  size="small"
                  onClick={() => {
                    setEditRecord({
                      ...record,
                    });
                    setEditFormVisible(true);
                  }}
                >
                  编辑
                </Button>
              </Space>
            ) : null;
          }
        },
      },

      {
        title: "登录名",
        dataIndex: "userCode",
        key: "userCode",
        width: 100,
      },
      {
        title: "用户姓名",
        dataIndex: "userName",
        key: "userName",
        width: 100,
      },
      {
        title: "用户类别",
        dataIndex: "type",
        key: "type",
        width: 100,
        render: (text: any, record: User) => {
          if (record.type === 1) {
            return <span>学校用户</span>;
          } else if (record.type === 2) {
            return <span>医院用户</span>;
          } else{
            return <span></span>;
          }
        },
      },
      {
        title: "所属医院",
        key: "hospitalName",
        dataIndex: "hospitalName",
        width: 120,
      },
      {
        title: "所属学校",
        key: "schoolName",
        dataIndex: "schoolName",
        width: 120,
      },
      {
        title: "增加受检人权限",
        key: "add",
        dataIndex: "add",
        width: 150,
        render: (text: any, record: User) => {
          return record.add ? <span>是</span> : <span>否</span>;
        },
      },
      {
        title: "修改受检人权限",
        key: "update",
        dataIndex: "update",
        width: 150,
        render: (text: any, record: User) => {
          return record.update ? <span>是</span> : <span>否</span>;
        },
      },
      {
        title: "删除受检人权限",
        key: "delete",
        dataIndex: "delete",
        width: 150,
        render: (text: any, record: User) => {
          return record.delete ? <span>是</span> : <span>否</span>;
        },
      },
      {
        title: "检测权限",
        key: "check",
        dataIndex: "check",
        width: 100,
        render: (text: any, record: User) => {
          return record.check ? <span>是</span> : <span>否</span>;
        },
      },
      {
        title: "查看报告权限",
        key: "report",
        dataIndex: "report",
        width: 100,
        render: (text: any, record: User) => {
          return record.report ? <span>是</span> : <span>否</span>;
        },
      },
      {
        title: "用户设置权限",
        key: "user",
        dataIndex: "user",
        width: 100,
        render: (text: any, record: User) => {
          return record.user ? <span>是</span> : <span>否</span>;
        },
      },
      {
        title: "导入导出权限",
        key: "data",
        dataIndex: "data",
        width: 100,
        render: (text: any, record: User) => {
          return record.data ? <span>是</span> : <span>否</span>;
        },
      },
      {
        title: "统计分析权限",
        key: "count",
        dataIndex: "count",
        width: 100,
        render: (text: any, record: User) => {
          return record.count ? <span>是</span> : <span>否</span>;
        },
      },
    ];
  };

  return (
    <div className={styles["page-main"]}>
      <Row>
        <Col span={6}>
        <span className={styles["header-text"]}>用户设置</span>
        </Col>
        <Col span={8}>
        <Button
                  type="primary"
                  onClick={() => {
                    if (!loginInfo.user.user) {
                      message.info("没有用户设置权限.");
                      return;
                    }
                    setAddFormVisible(true);
                  }}
                >
                  添加用户
                </Button>
        </Col>
      </Row>
      <Row>
        <Col span={24}>
        <Table
                className={styles["table"]}
                bordered
                pagination={false}
                columns={buildColumns()}
                //scroll={{ x: 500, y: 400 }}
                scroll={{ x: 510, y: "calc(100vh - 400px)" }}
                //dataSource={users}
                dataSource={users}
              />
            </Col>
        </Row>     
        <AddForm
          visible={addFormVisible}
          add={add}
          setInvisible={() => setAddFormVisible(false)}
        />
        <EditForm
          visible={editFormVisible}
          update={update}
          setInvisible={() => setEditFormVisible(false)}
          editRecord={editRecord}
        />
      </div>
  );
};
